import { performRequest } from "../performRequest"



export const getDirectoryApi = (params) => {
    return performRequest("get", "api/ess/user/",params)
}
